import { useRoute, useRouter } from 'vue-router';
import { useRootStore } from '@/stores/useRootStore';

//const route = useRoute();
//const router = useRouter();
// const rootStore = useRootStore();

export const goStoreMainLink = (url: string, winOpen: boolean, id: string | number, feedType: string): void => {

  if (winOpen) {
    window.open(url)
  } else {
    if (url.includes(getBio11Url())|| url.includes('http')) {
      window.location.href = url;
    } else {
      navigateTo(url);
    }
    /*if (this.isIOS()) {
      window.location.replace(url)
    } else {
      window.location.href = url
    }*/
  }
}

 // 주문/결제 페이지 이동
 export const goOrderPay=(params:string, isTtobak = false, replace = false, isCombined = false) =>{
  let url = ''
  if (isCombined) {
    url = `/order/setCombineShipping?${params}`;
  } else if (isTtobak) {
    url = `/order/setRoutineShipping?${params}`;
  } else {
    url = `/order/settle?${params}`;
  }

  if (replace) {
    navigateTo(url , {replace : true});
  } else {
    navigateTo(url);
  }
  
};


//이전페이지로 이동
export const clickBack = (router : any) => {
  router.back();
}

export const getCart = async() =>{
    navigateTo('/order/cart')
};

// 접속 환경에 따른 메인페이지 이동
export const goMain = () => {
  if (isPcWeb()) {
    window.location.href = import.meta.env.VITE_TTOBAK_WEB_URL
  } else {
    navigateTo('/');
  }
}